import { FC, SVGProps } from 'react';

import BubblesBig from '~/assets/icons/bubbles-big.svg?react';
import CalendarBig from '~/assets/icons/calendar-big.svg?react';
import ClockBig from '~/assets/icons/clock-big.svg?react';
import Compass from '~/assets/icons/compass-big.svg?react';
import Confetti from '~/assets/icons/confetti-big.svg?react';
import ContentLoadError from '~/assets/icons/content-load-error-big.svg?react';
import EmptyCompleted from '~/assets/icons/empty-completed.svg?react';
import EmptyGeneric from '~/assets/icons/empty-generic.svg?react';
import EmptyInfo from '~/assets/icons/empty-info.svg?react';
import Fail from '~/assets/icons/fail-big.svg?react';
import Gear from '~/assets/icons/gear-big.svg?react';
import Gift from '~/assets/icons/gift-big.svg?react';
import HealthInsurance from '~/assets/icons/health-insurance-big.svg?react';
import Hourglass from '~/assets/icons/hourglass-big.svg?react';
import Info from '~/assets/icons/info-big.svg?react';
import Lock from '~/assets/icons/lock-big.svg?react';
import Mailbox from '~/assets/icons/mailbox-big.svg?react';
import Send from '~/assets/icons/send-big.svg?react';
import ShieldCheck from '~/assets/icons/shield-check-big.svg?react';
import Confirm from '~/assets/icons/success-big.svg?react';
import Warn from '~/assets/icons/warn-big.svg?react';
import { classNames } from '~/utils/styles';

export const BIG_ICONS = {
    calendar: CalendarBig,
    communication: BubblesBig,
    clock: ClockBig,
    confirm: Confirm,
    congrats: Confetti,
    contentLoadError: ContentLoadError,
    empty: EmptyGeneric,
    emptyGeneric: EmptyGeneric,
    emptyInfo: EmptyInfo,
    emptyCompleted: EmptyCompleted,
    healthInsurance: HealthInsurance,
    info: Info,
    warn: Warn,
    lock: Lock,
    compass: Compass,
    hourglass: Hourglass,
    fail: Fail,
    confetti: Confetti,
    mailbox: Mailbox,
    send: Send,
    gift: Gift,
    gear: Gear,
    shieldCheck: ShieldCheck,
};

export type BigIconName = keyof typeof BIG_ICONS;

type BigIconProps = {
    icon: BigIconName;
    size?: number;
    label?: string;
    className?: string;
};

export default function BigIcon({ icon, size = 80, label, className }: BigIconProps) {
    const Icon = BIG_ICONS[icon] as FC<SVGProps<SVGSVGElement>>;
    return (
        <Icon
            aria-label={label}
            width={size}
            height={size}
            className={classNames({
                'ui-big-icon': true,
                [`${className}`]: Boolean(className),
            })}
        />
    );
}
